export const StyleListMenu = {
  borderBottom: "0.647405px solid rgba(255, 255, 255, 0.15)",
  color: "#ffffff",
  marginTop: " 20px !important",
  paddingBottom: "20px !important",
  fontSize: "14px",
};

